import React, { useEffect, useState } from "react";
import group1 from "../../../assests/Vector.png";
import BoxComponent from "./BoxComponent";
import grp1 from "../../../assests/grp1.png";
import grp5 from "../../../assests/grp5.png";
import grp2 from "../../../assests/grp2.png";
import grp3 from "../../../assests/grp3.png";
import grp4 from "../../../assests/grp4.png";
import {
  Activity,
  ArrowLeft,
  Calendar,
  Database,
  FileText,
  Globe,
  Info,
  Users,
  TableCellsMerge,
  Loader2,
  PackageSearch,
  FileSliders,
  Layers,
} from "lucide-react";
import { Button } from "../ui/Button";
import { ScoreIndicator } from "../ui/ScoreIndicator";
import { Card } from "../ui/Card";
import { Badge } from "../ui/Badge";
import axiosInstance from "../../../axiosInstanceSetup";
import { FaArrowLeft } from "react-icons/fa";
import heartLoading from "../../../assests/heartLoading.gif"
import preloader from "../../../assests/preloader1.gif";
import { ProfilingResultView } from "./ProfilingResult";
import ProductDetail from "./ProductDetail";
import { DQResult } from "./DQResult";
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import Tooltip from '@mui/material/Tooltip';

const ordersTableDetails = [
  {
    field_name: "order_id",
    type: "text",
    description: "An internal ID that identifies an order in the online shop",
    example: "243c25e5-0081-4309-aeab-6d5d5b6cb5e2",
    constraints: [
      "primary",
      "required",
      "unique",
      "format:uuid",
      "restricted",
      "PII",
    ],
    business_timestamp:
      "The business timestamp in UTC when the order was successfully registered",
  },
  {
    field_name: "order_timestamp",
    type: "timestamp",
    description:
      "The business timestamp in UTC when the order was successfully registered in the source system and the payment was successful",
    example: "2024-09-09T08:30:00Z",
    constraints: ["required"],
    business_timestamp: "When order was placed",
  },
  {
    field_name: "order_total",
    type: "long",
    description: "Total amount the smallest monetary unit (e.g., cents)",
    example: "9999",
    constraints: ["required"],
    business_timestamp: "Order total amount",
  },
  {
    field_name: "customer_id",
    type: "text",
    description: "Unique identifier for the customer",
    example: "CUST-12345-67890",
    constraints: ["minLength:10", "maxLength:20"],
    business_timestamp: "Customer identification",
  },
  {
    field_name: "customer_email_address",
    type: "text",
    description:
      "The email address, as entered by the customer. The email address was not verified",
    example: "customer@example.com",
    constraints: ["required", "format:email", "sensitive", "PII"],
    business_timestamp: "Customer contact information",
  },
  {
    field_name: "processed_timestamp",
    type: "timestamp",
    description:
      "The timestamp when the record was processed by the data platform",
    example: "2024-09-09T09:15:30Z",
    constraints: ["required"],
    business_timestamp: "Data processing time",
  },
];

const getTypeColor = (type) => {
  switch (type.toUpperCase()) {
    case "STRING":
      return "primary";
    case "INTEGER":
      return "success";
    case "DECIMAL":
      return "warning";
    case "DATE":
      return "error";
    default:
      return "secondary";
  }
};

export const AssetsDetails = ({ subdomain, productDetails, profilingResult, dqResult, onBack, onL5Click }) =>  {
  const [activeTab, setActiveTab] = useState("Data Table");
  const [searchTerm, setSearchTerm] = useState("");
  const [assetOverview, setAssetOverview] = useState();
  const [tableOverview, setTableOverview] = useState();
  const [profilingResultByAsset, setProfilingResultByAsset] = useState(null);
  const [dqResultByAsset, setDQResultByAsset] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);

  const fetchAssetInformation = async () => {
    try {
      setIsLoading(true);

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/assets/${subdomain.data_asset_id}`
      );

      if (response.status === 200) {
        setAssetOverview(response?.data?.assetsOverview);
        setTableOverview(response?.data?.tableDetails);
        setIsLoading(false);
      }
    } catch (e) {
      console.error("getting error whie fetching the asset information");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetInformation();
    const filteredRows = profilingResult?.filter((res) => res.data_asset_name.toLowerCase() === (subdomain.data_asset_name.toLowerCase()));
    setProfilingResultByAsset(filteredRows[0]);
    const filteredDQRows = dqResult?.find((res) => res.data_asset_id === (subdomain.data_asset_id));
    const filteredRules = filteredDQRows.rules.filter((rule) => rule.rule_name !== "row_count");
    setDQResultByAsset({...filteredDQRows, rules: filteredRules});
  }, []);

  if (isLoading) {
    return (
       <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
                         <div className="flex flex-col items-center space-y-3">
                           <img src={preloader} alt="Loading..." width={200} />
                           <span className="text-gray-700 text-[20px]">
                             Please wait while loading the resources...
                           </span>
                         </div>
                       </div>
    );
  }

  const filteredAttributes = tableOverview && tableOverview.filter(
    (attr) =>
      attr.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      attr.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredOrdersAttributes = ordersTableDetails.filter(
    (attr) =>
      attr.field_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      attr.type.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const tabs = [
    { id: "Data Table", label: "Assets Table", icon: TableCellsMerge },
    { id: "Product", label: "Product", icon: PackageSearch },
    { id: "Profiling Result", label: "Profiling Result", icon: FileSliders },
    { id: "DQResult", label: "Data Quality Result", icon: FileSliders }
  ];

  const assetData = assetOverview  ;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const totalPages = filteredAttributes && Math.max(
    1,
    Math.ceil(filteredAttributes.length / itemsPerPage)
  );

  const validCurrentPage = Math.min(currentPage, totalPages);

  const indexOfFirstItem = (validCurrentPage - 1) * itemsPerPage;
  const indexOfLastItem =filteredAttributes && Math.min(
    indexOfFirstItem + itemsPerPage,
    filteredAttributes.length
  );
  const currentSubdomains = filteredAttributes && filteredAttributes.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(
      1,
      validCurrentPage - Math.floor(maxVisiblePages / 2)
    );
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    buttons.push(
      <button
        key="prev"
        className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        disabled={validCurrentPage === 1}
        onClick={() => handlePageChange(validCurrentPage - 1)}
      >
        Previous
      </button>
    );

    // First page and ellipsis
    if (startPage > 1) {
      buttons.push(
        <button
          key={1}
          className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          onClick={() => handlePageChange(1)}
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(
          <span key="ellipsis1" className="px-3 py-2 text-sm text-gray-500">
            ...
          </span>
        );
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={`px-3 py-2 text-sm border rounded-md transition-colors ${
            validCurrentPage === i
              ? "bg-[#bb1ccc] text-white border-[#bb1ccc] shadow-sm"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    // Last page and ellipsis
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="ellipsis2" className="px-3 py-2 text-sm text-gray-500">
            ...
          </span>
        );
      }
      buttons.push(
        <button
          key={totalPages}
          className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    // Next button
    buttons.push(
      <button
        key="next"
        className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        disabled={validCurrentPage === totalPages}
        onClick={() => handlePageChange(validCurrentPage + 1)}
      >
        Next
      </button>
    );

    return buttons;
  };

  const formatDateWithSuffix = (dateStr) => {
    if (!dateStr) return "N/A"; // or return an empty string ""

    const date = new Date(dateStr);
    if (isNaN(date)) return "Invalid Date";

    const day = date.getDate();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return (
      <div style={{ fontSize: "10px" }}>
        {day}
        {getOrdinal(day)}, {month} {year}
      </div>
    );
  };

  const parseWeightage = (weightageStr) => {
    try {
      return JSON.parse(weightageStr);
    } catch {
      return {};
    }
  };

  const weightage = assetData && assetData.weightage && parseWeightage(assetData.weightage);

 

  return (
    <div className="space-y-8 ">
      {/* Header */}
      {/* <div className="  flex absolute justify-end gap-2.5 right-6 top-8 mt-[35px]">
        <button
         style={{marginTop:"35px"}}
          onClick={onBack}
          className="text-[#0000a0] hover:text-white transition-colors duration-200 border border-[#0000a0] p-2 rounded-lg flex items-center gap-2 hover:bg-[#0000a0] hover:shadow-lg px-4"
        >
       <FaArrowLeft/>   Go Back
        </button>
      </div> */}

      {/* Subdomain Summary */}
      <div className="rounded-lg pt-4 pb-4 text-white relative">
        {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h1 className="text-3xl font-bold text-black mb-2  break-words whitespace-normal overflow-hidden w-[70%]">
            {subdomain.data_asset_name}
          </h1>

          
        </div> */}
          {/* <div className="flex justify-between items-start flex-wrap gap-4">
    <h1 className="text-3xl font-bold text-black break-words whitespace-normal overflow-hidden">
      {subdomain.data_asset_name}
    </h1>

    <button
      onClick={onBack}
      className="text-[#0000a0] hover:text-white transition-colors duration-200 border border-[#0000a0] p-2 rounded-lg flex items-center gap-2 hover:bg-[#0000a0] hover:shadow-lg px-4"
    >
      <FaArrowLeft /> Go Back
    </button>
  </div> */}
   <div className="flex justify-between items-center flex-wrap gap-4">
    {/* Left side: Title */}
    <h1 className="text-2xl font-bold text-black break-words whitespace-normal overflow-hidden max-w-[80%]">
      {subdomain.data_asset_name}
    </h1>

    {/* Right side: Go Back button */}
    <button
      onClick={onBack}
      className="text-[#bb1ccc] hover:text-white transition-colors duration-200 border border-[#bb1ccc] p-2 rounded-lg flex items-center gap-2 hover:bg-[#bb1ccc] hover:shadow-lg px-4"
    >
      <FaArrowLeft /> Go Back
    </button>
  </div>



        <p className="text-lg text-black mb-4 leading-relaxed">
          {subdomain.description}
        </p>

        {/* Quick Stats */}
        <div className="p-1   bg-[#fff]">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-3 p-4  rounded-lg ">
           
   <BoxComponent
  value={assetData?.data_asset_score ?? "N/A"}
  label="Data Quality"
  // icon={grp4}
  iconBg="#80C6AD"   
  cardBg="#E6F1F9"
    iconColor='#fff'

/>


            {/* <div className="bg-white p-6 border rounded">
              <div className="text-center grid justfy-center">
                <div
                  style={{ width: "30px", height: "30px" }}
                  className="bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3"
                >
                  <LocationPinIcon className="w-6 h-6 text-emerald-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">
                  Region
                </h3>
                <Tooltip 
                  title={assetData ? `${assetData.region}, ${assetData.country}` : ''} 
                  arrow 
                  placement="top"
                >
                  <p className="text-xl font-bold text-emerald-600 truncate px-2 cursor-help">                 
                    {assetData && assetData.region}, {assetData && assetData.country}
                  </p>
                </Tooltip>
              </div>
            </div> */}
            <BoxComponent
  label="Region"
  iconBg="#9897FF"   
  cardBg="#E6F1F9"
    iconColor='#fff'

  value={
    <Tooltip
      title={assetData ? `${assetData.region}, ${assetData.country}` : ""}
      arrow
      placement="top"
    >
      <p className="text-[20px]  cursor-help overflow-hidden whitespace-nowrap text-ellipsis inline-block max-w-[43px]">
        {assetData
          ? `${assetData.region}, ${assetData.country}`
          : "N/A"}
      </p>
    </Tooltip>
  }
/>

            {/* <div className="bg-white p-6 border rounded">
              <div className="text-center grid justfy-center">
                <div
                  style={{ width: "30px", height: "30px" }}
                  className="bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3"
                >
                  <FileText className="w-6 h-6 text-amber-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">
                  Records
                </h3>
                <p className="text-xl font-bold text-amber-600">
                  {assetData && parseInt(assetData.data_row_count).toLocaleString()}
                </p>
              </div>
            </div> */}
            <BoxComponent
  value={assetData ? parseInt(assetData.data_row_count).toLocaleString() : "0"}
  label="Records"
  iconBg="#0171C1"   
  cardBg="#E6F1F9"
    iconColor='#fff'

/>

            {/* <div className="bg-white p-6 border rounded">
              <div className="text-center grid justfy-center">
                <div
                  style={{ width: "30px", height: "30px" }}
                  className="bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3"
                >
                  <Layers className="h-8 w-8 text-purple-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-1">
                  Data Layer
                </h3>
                <div>
                  {assetData && assetData.target_layer ? (
                    <div
                      className="inline-block px-3 py-1 rounded-full text-sm font-semibold text-center"
                      style={{
                        backgroundColor: (() => {
                          const type = assetData.target_layer.toLowerCase();
                          switch (type) {
                            case 'bronze': return '#CD7F32';
                            case 'silver': return '#C0C0C0';
                            case 'gold': return '#FFD700';
                            case 'ingestion': return '#10B981';
                            default: return '#6B7280';
                          }
                        })(),
                        color: (() => {
                          const type = assetData.target_layer.toLowerCase();
                          switch (type) {
                            case 'gold':
                            case 'silver': return '#1f2937';
                            default: return 'white';
                          }
                        })()
                      }}
                    >
                      {(() => {
                        const type = assetData.target_layer;
                        if (!type) return 'N/A';
                        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
                      })()}
                    </div>
                  ) : (
                    <p className="text-sm text-gray-500">N/A</p>
                  )}
                </div>
              </div>
            </div> */}
            <BoxComponent
  label="Data Layer"
  iconBg="#0101A7"   
  cardBg="#E6F1F9"
    iconColor='#fff'
  value={
    assetData && assetData.target_layer ? (
      <div
        className="inline-block px-3 py-1 rounded-full text-sm font-semibold text-center"
        style={{
          backgroundColor: (() => {
            const type = assetData.target_layer.toLowerCase();
            switch (type) {
              case "bronze":
                return "#CD7F32";
              case "silver":
                return "#C0C0C0";
              case "gold":
                return "#FFD700";
              case "ingestion":
                return "#10B981";
              default:
                return "#6B7280";
            }
          })(),
          color: (() => {
            const type = assetData.target_layer.toLowerCase();
            switch (type) {
              case "gold":
              case "silver":
                return "#1f2937"; // dark text
              default:
                return "white"; // white text for darker backgrounds
            }
          })(),
        }}
      >
        {(() => {
          const type = assetData.target_layer;
          if (!type) return "N/A";
          return (
            type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
          );
        })()}
      </div>
    ) : (
      <p className="text-sm text-gray-500">N/A</p>
    )
  }
/>

          
            <BoxComponent
  value={<span className="text-[18px]">
      {assetData?.frequency || "N/A"}
    </span>}
  label="Frequency"
  iconBg="#404040"   
  cardBg="#E6F1F9"
  iconColor='#fff'
/>
          </div>
        </div>
         <div>
          {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mb-4 p-6 bg-gray-100 rounded border">
            Data Quality Metrics
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-sm border p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Data Quality Weightage
                </h3>
                <div className="space-y-4">
                  {assetData && assetData.weightage && Object.entries(weightage).map(([key, value]) => (
                    <div
                      key={key}
                      className="flex items-center justify-between"
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-slate-600 rounded-full"></div>
                        <span className="text-sm font-medium text-gray-700 capitalize">
                          {key.replace("_", " ")}
                        </span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-32 bg-gray-200 rounded-full h-2">
                          <div
                            className="bg-slate-600 h-2 rounded-full transition-all duration-700"
                            style={{ width: `${value}%` }}
                          ></div>
                        </div>
                        <span className="text-sm font-semibold text-gray-900 w-8">
                          {value}%
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            Location & Product Info 
            <div>
            <div className="space-y-6">
              <div className="bg-white rounded-lg shadow-sm border p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Data Product
                </h3>
                <div className="flex items-start space-x-3">
                  <FileText
                    style={{ width: "20px" }}
                    className="h-5 text-gray-400 mt-1"
                  />
                  <div>
                    <p className="font-medium text-gray-900">
                      {assetData && assetData.data_prod_name}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-sm border p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Created By
                </h3>
                <div className="flex items-start space-x-3">
                  <FileText
                    style={{ width: "20px" }}
                    className="h-5 text-gray-400 mt-1"
                  />
                  <div>
                    <p className="font-medium text-gray-900">
                      {assetData && assetData.created_by}
                    </p>
                  </div>
              </div>
            </div>
            </div>
            </div>
          </div> */}
        </div>
      </div>

      <div className="border-b border-gray-200 mt-0 ">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? "border-[#bb1ccc] text-[#bb1ccc]"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <tab.icon  size={18} />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === "Data Table" && (
          <div className="space-y-6">
            {/* Search */}
            <div className="relative">
              {/* <Search className="absolute left-13 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" /> */}
              <input
                type="text"
                placeholder="Search attributes..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 max-w-md w-full h-[45px]"
              />
            </div>

            {/* Overview Table */}
            <Card padding="none">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-[#bb1ccc] border-b border-gray-200">
                    <tr>
                      <th className="text-left py-3 px-6 font-medium text-white">
                        Field Name
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-white">
                        Type
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-white">
                        Description
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-white">
                        Example
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-white">
                        Constraints
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {currentSubdomains.map((attr) => (
                      <tr
                        key={attr.attribute_id}
                        className="hover:bg-gray-50 transition-colors"
                      >
                        <td className="py-4 px-6">
                          <div className="font-medium text-gray-900">
                            {attr.name}
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <Badge variant={getTypeColor(attr.type)} size="sm">
                            {attr.type}
                          </Badge>
                        </td>
                        <td className="py-4 px-6 text-gray-600">
                          {attr.metadata || "No description available"}
                        </td>
                        <td className="py-4 px-6 text-gray-600">
                          {attr.sample}
                        </td>
                        <td className="py-4 px-6 text-gray-600">
                          <div className="flex flex-wrap gap-1">
                          { attr?.constraints ? attr?.constraints?.map((constraint, i) => (
                            <Badge
                              key={i}
                              variant={
                                constraint === "PII"
                                  ? "error"
                                  : constraint === "required"
                                  ? "warning"
                                  : "secondary"
                              }
                              size="sm"
                            >
                              {constraint}
                            </Badge>
                          )) : "N/A"}
                        </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        )}

        {activeTab === "Product" && (
          <Card>
            <ProductDetail product={productDetails} />
          </Card>
        )}

        {activeTab === "Profiling Result" && (
          <Card>
            <ProfilingResultView results={profilingResultByAsset?.columns}/> 
          </Card>
        )}

        {activeTab === "DQResult" && (
          <Card>
            {dqResultByAsset?.rules ?
              <DQResult results={dqResultByAsset}/> :
              <span>No rules to display</span>
            }
          </Card>
        )}

        {totalPages > 1 && activeTab === 'Data Table' &&  (
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 pt-6 border-t border-gray-200">
            <div className="text-sm text-gray-600">
              Showing{" "}
              <span className="font-medium">{indexOfFirstItem + 1}</span> to{" "}
              <span className="font-medium">{indexOfLastItem}</span> of{" "}
              <span className="font-medium">{filteredAttributes && filteredAttributes.length}</span>{" "}
              results
              {/* {searchTerm && (
                  <span className="text-gray-500"> (filtered from {domain.domains_L2.length} total)</span>
                )} */}
            </div>
            <div className="flex space-x-1">{renderPaginationButtons()}</div>
          </div>
        )}
      </div>
    </div>
  );
};
